// ported from supportFetch. depends on being called in a context
// where csrf is present in document
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const defaultClientFetch = (
  url: RequestInfo | URL,
  init?: RequestInit,
) => {
  const csrfToken = document.documentElement.getAttribute('data-csrf');

  if (!csrfToken) {
    throw new Error('No CSRF element available on page');
  }

  const augmentedHeaders = {
    ...((init && init.headers) || {}),
    'x-stripe-csrf-token': csrfToken,
    'X-Requested-With': 'fetch',
  };

  const augmentedInit = {
    credentials: 'same-origin',
    ...(init || {}),
    headers: augmentedHeaders,
  } as const;

  return fetch(url, augmentedInit);
};
